import {
    Env
} from './env.js';
import {
    Urlparam
} from './urlparam.js'; // URLパラメータ
import {
    Dmenu
} from './dmenu.js'; //ドロワーメニュー
import {
    Swp
} from './swp.js'; //Swiper
export class Opening {
    constructor() {
        this.body = {}
        this.html = {}
        this.env = {}
        this.paramAncher = {}
        this.openingFlg = false

        //original slider (SP/PC)
        this.slideTimer = {}
        this.slideCount = 1
        this.dmenu = {}

        //swiper(Tablet)
        this.slidersInitFlg = false
        this.coverElem = {}
    }


    onResize() {
        let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);


        // クリックとタップ判定　
        if (window.ontouchstart === null) {
            if (windowWidth > 600) {
                console.log('index-cover タッチデバイス Tablet');
                this.coverElem.querySelector('.index-cover-swiper').classList.remove('hide');
                this.coverElem.querySelector('.index-cover-default').classList.add('hide');

                // Swiper
                if (document.getElementById('js-index-cover-swiper') && this.slidersInitFlg !== true) {
                    this.slidersInitFlg = true;
                    this.sliders = new Swp();
                    this.sliders.init();
                }

            } else {
                console.log('index-cover タッチデバイス SP');
                this.coverElem.querySelector('.index-cover-swiper').classList.add('hide');
                this.coverElem.querySelector('.index-cover-default').classList.remove('hide');
            }
        } else {
            //console.log('index-cover PC');
            if (document.getElementById('js-index-cover-swiper')) {
                this.coverElem.querySelectorAll('.index-cover-swiper')[0].classList.add('hide');
                this.coverElem.querySelectorAll('.index-cover-default')[0].classList.remove('hide');
            }
        }
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];



        // 環境
        this.env = new Env();
        this.env.detectEnv();

        // URLパラメータ
        this.paramAncher = new Urlparam();
        this.paramAncher.getParam('op', location.href);

        if (document.getElementById('index-cover')) {
            this.coverElem = document.getElementById('index-cover');
            if (this.env.browser.ie11 || this.paramAncher.param == 0) {
                // Openingなし
                this.openingFlg = false;
            } else {
                this.openingFlg = true;
            }
        }
    }

    startOpening() {
        //this.coverElem = document.getElementById('index-cover');
        this.coverElem.classList.add('is-show-slider-0');

        if (this.body.classList.contains('index-slider-pattern-2')) {
            //slider-pattern2
            window.setTimeout(() => {
                this.coverElem.classList.add('is-show-slider-1');
            }, 900);
        }

        window.setTimeout(() => {
            this.afterOpening();
        }, 1800);

        window.setTimeout(() => {
            this.slideTimer = setInterval(() => {
                this.slidePlay();
            }, 3600);
        }, 800);
    }

    skipOpening() {
        this.afterOpening();
    }

    afterOpening() {
        this.body.classList.add('show-menu');
    }

    slidePlay() {
        let inview = false;
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        let windowScrollY = window.scrollY || window.pageYOffset;
        if (windowScrollY < 1.5 * windowHeight) {
            inview = true;
        }
        if (inview && !this.body.classList.contains('is-modal-show')) {
            this.slideCount += 1;

            if (this.slideCount == 4) {
                this.slideCount = 1;
            }

            if (document.getElementById('index-cover')) {
                let elem = document.getElementById('index-cover');
                if (this.slideCount == 3) {
                    elem.classList.remove('is-show-slider-1');
                    elem.classList.add('is-show-slider-3');
                } else if (this.slideCount == 2) {
                    elem.classList.remove('is-show-slider-3');
                    elem.classList.add('is-show-slider-2');
                } else if (this.slideCount == 1) {
                    elem.classList.remove('is-show-slider-2');
                    elem.classList.add('is-show-slider-1');
                }
            }
        }
    }

    showMainContent() {
        let template;
        let clone;
        // HomeのOP以下のコンテンツ
        if (document.getElementById('index-content-template')) {
            template = document.getElementById('index-content-template');
            clone = template.content.cloneNode(true);
            document.getElementById('js-index-content-container').appendChild(clone);
        }

        //dmenu
        this.dmenu = new Dmenu();
        this.dmenu.envCheck();
        this.dmenu.init();
    }

}